import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const InfoBlock = ({ icon: Icon, label, children }) => (
  <div className="flex items-start gap-5">
    <div className="w-12 h-12 border border-[#1A1F24]/20 flex items-center justify-center shrink-0">
      <Icon className="w-5 h-5 text-[#2E4F4F]" strokeWidth={1.5} />
    </div>
    <div>
      <p className="text-xs uppercase tracking-[0.25em] text-[#4A5568] mb-2">{label}</p>
      {children}
    </div>
  </div>
);

const ContactInfo = () => {
  const { t } = useLang();
  return (
    <div className="space-y-8">
      <InfoBlock icon={Phone} label={t.contact.callUs}>
        <a
          data-testid="contact-phone"
          href="tel:+19129334539"
          className="text-[#1A1F24] hover:text-[#2E4F4F] transition-colors text-lg"
        >
          +1 912-933-4539
        </a>
      </InfoBlock>
      <InfoBlock icon={Mail} label={t.contact.emailUs}>
        <a
          data-testid="contact-info-email"
          href="mailto:rsv@hrmembers.com"
          className="text-[#1A1F24] hover:text-[#2E4F4F] transition-colors text-lg break-all"
        >
          rsv@hrmembers.com
        </a>
      </InfoBlock>
      <InfoBlock icon={MapPin} label={t.contact.offices}>
        <div className="space-y-3 text-[#4A5568]">
          <p data-testid="address-us">
            <span className="text-[#1A1F24] font-medium">USA · </span>
            30 Gould N Ste, Sheridan, Wyoming, 82801
          </p>
          <p data-testid="address-mx">
            <span className="text-[#1A1F24] font-medium">MEX · </span>
            SM 6A, Cancún, Quintana Roo, 77500
          </p>
        </div>
      </InfoBlock>
    </div>
  );
};

export default ContactInfo;
